/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./Web192081.css";

function Web192081(props) {
  const { x40370191930_E4B5C31906_6K, option2, group138, path128 } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-81 screen">
        <div className="overlap-group1-9">
          <img className="x40370191930_e4b5c31906_6k-1" src={x40370191930_E4B5C31906_6K} />
          <div className="rectangle-2-18 border-1px-dove-gray"></div>
          <div className="option-2 lato-bold-black-140px">{option2}</div>
          <div className="overlap-group-19">
            <div className="group-141-4">
              <div className="group-140-4">
                <div className="group-139-4">
                  <img className="group-138-4" src={group138} />
                </div>
              </div>
            </div>
            <img className="path-128-4" src={path128} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Web192081;
